// extracted by mini-css-extract-plugin
module.exports = {"buoyCarousel":"BuoyCarousel_buoyCarousel__AxVyI","errorMessage":"BuoyCarousel_errorMessage__rGGPI"};